import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-HIPP",
  "use": "icon-HIPP-usage",
  "viewBox": "0 0 20 25",
  "content": "<symbol viewBox=\"0 0 20 25\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-HIPP\">\r\n<path d=\"M19.5 24H1V7.86166M18.6444 7.86166V24M8.5453 3.3H11.714M1 17.8667H18.6444M1 1H18.6444V5.6H1V1Z\" stroke=\"\" stroke-width=\"2\" stroke-miterlimit=\"10\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol